import { render, staticRenderFns } from "./SourcePriorityChangeMessage.vue?vue&type=template&id=08b3abc3&scoped=true&"
import script from "./SourcePriorityChangeMessage.vue?vue&type=script&lang=js&"
export * from "./SourcePriorityChangeMessage.vue?vue&type=script&lang=js&"
import style0 from "./SourcePriorityChangeMessage.vue?vue&type=style&index=0&id=08b3abc3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b3abc3",
  null
  
)

export default component.exports